const isRegion = (region) => !!(region === null || region === void 0 ? void 0 : region.id);
export default isRegion;
